import ModelShowDetails from "domains/models/components/ModelShow/Details";
import ModelShowHeader from "domains/models/components/ModelShow/Header";
import ModelShowImages from "domains/models/components/ModelShow/Images";
import ModelShowMoreDetails from "domains/models/components/ModelShow/MoreDetails";
import {
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "domains/ui/components/Tabs";
import { createTabs, useTabs } from "domains/ui/hooks/useTabs";
import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

import { Center, Spinner, Text, VStack } from "@chakra-ui/react";

const TABS = createTabs({
  ids: ["OVERVIEW", "IMAGES", "DETAILS"],
  items: {
    OVERVIEW: "overview",
    IMAGES: "images",
    DETAILS: "details",
  },
});

interface ModelShowLayoutProps {
  model: GetModelsByModelIdApiResponse["model"];
  onAddToComposition?: () => void;
  contentScrollRef?: React.RefObject<HTMLDivElement>;

  isOnLoraCatalog?: boolean;
}

export default function ModelShowLayout({
  model,
  onAddToComposition,
  contentScrollRef,
  isOnLoraCatalog = false,
}: ModelShowLayoutProps) {
  const { tabIndex, onTabChange } = useTabs(TABS);

  if (!model) {
    return (
      <Center>
        <Spinner />
        <Text>Loading model data</Text>
      </Center>
    );
  }

  return (
    <VStack align="stretch" w="full" h="full" pt={6} px={9} spacing={4}>
      <ModelShowHeader
        model={model}
        isOnLoraCatalog={isOnLoraCatalog}
        onAddToComposition={onAddToComposition}
      />

      <VStack align="stretch" h="full" spacing={4}>
        {tabIndex !== undefined && (
          <Tabs h="full" index={tabIndex} isLazy onChange={onTabChange}>
            <TabList>
              <Tab>Overview</Tab>
              <Tab>Generations</Tab>
              <Tab>Details</Tab>
            </TabList>
            <TabIndicator key={`tab-indicator-${tabIndex}`} />
            <TabPanels>
              <TabPanel>
                <ModelShowDetails
                  model={model}
                  isOnLoraCatalog={isOnLoraCatalog}
                />
              </TabPanel>
              <TabPanel>
                <ModelShowImages
                  model={model}
                  contentScrollRef={contentScrollRef}
                />
              </TabPanel>
              <TabPanel>
                <ModelShowMoreDetails model={model} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        )}
      </VStack>
    </VStack>
  );
}
